import { Component } from 'react'
import { observer, inject } from 'mobx-react'
import _ from 'lodash'

import { RoundedCard, CardField, CardFieldError, Drawer, Spacer } from '../../../components'
import { numberToDollars } from '../../../utils'
import { planTypeIdToAccountKey } from '../../../constants'
import EditEmployerContributions from './EditEmployerContributions'

class EditEmployerContributionsCard extends Component {
  state = { editActive: false }

  handleEdit = () => this.setState({ editActive: true })

  handleCancel = () => this.setState({ editActive: false })

  render() {
    const {
      features: { editInstitutionalAccount },
    } = this.props.store
    const {
      account: {
        employerContrib,
        employerMatch,
        companyMatchRate,
        companyMatchRateMax,
        companyMatchDlrMax,
        profitSharing,
        profitSharingRate,
        type,
        planType,
        contributionTiers,
        employerContributions,
      },
      control: { employerContribution },
    } = this.props.account

    const canEditEmployerContributions = type !== 'Institutional' && employerContribution

    const trueEmployerMatch = type === 'Institutional' ? employerMatch : employerContrib

    const showProfitSharing = _.includes(['401k', '403b', '401a'], planTypeIdToAccountKey[planType])

    const employerContributionDollarMax =
      employerContributions &&
      employerContributions.length > 0 &&
      employerContributions[0].employerContributionDollarMax

    return (
      <RoundedCard
        title='Employer contributions'
        handleEdit={canEditEmployerContributions ? this.handleEdit : null}>
        {editInstitutionalAccount ? (
          <>
            {trueEmployerMatch && (
              <>
                <CardField label='Employer match?' value={trueEmployerMatch ? 'Yes' : 'No'} />
                <Spacer space='8px' />
              </>
            )}
            {contributionTiers && contributionTiers.length > 0 && (
              <>
                <CardField
                  type='header'
                  label='Match rate(s)'
                  value='Savings rate'
                  subValue='Percent matched per dollar'
                  subValueSmall={false}
                />
                <Spacer space='4px' />
                {contributionTiers.map((tier, index) => {
                  const lastTier = index === contributionTiers.length - 1
                  return (
                    <div key={index}>
                      <CardField
                        value={
                          index === 0
                            ? `First ${numberToDollars(tier?.to, true)}%`
                            : `Next ${numberToDollars(tier?.to - tier?.from, true)}%`
                        }
                        subValue={`${numberToDollars(tier?.percentContribution, true)}%`}
                        subValueSmall={false}
                      />
                      <Spacer space='4px' />
                      {lastTier && (
                        <>
                          <CardField
                            value={`Above ${numberToDollars(tier?.to, true)}%`}
                            subValue='No match'
                            subValueSmall={false}
                          />
                          <Spacer space='8px' />
                        </>
                      )}
                    </div>
                  )
                })}
              </>
            )}
            {trueEmployerMatch && (
              <CardField
                label='Maximum employer contribution in dollars'
                value={
                  employerContributionDollarMax
                    ? `$${numberToDollars(employerContributionDollarMax, true)}`
                    : 'Not capped'
                }
              />
            )}
            {showProfitSharing && profitSharing !== null && <Spacer space='8px' />}
          </>
        ) : (
          <>
            {trueEmployerMatch !== null && (
              <CardField label='Employer match?' value={trueEmployerMatch ? 'Yes' : 'No'} />
            )}

            <div>
              {trueEmployerMatch && companyMatchRate !== null && (
                <CardField
                  label='Per dollar match rate'
                  value={`${numberToDollars(companyMatchRate, true)}%`}
                />
              )}

              {trueEmployerMatch && companyMatchRateMax !== null && (
                <CardField
                  label='Max percent match'
                  value={`${numberToDollars(companyMatchRateMax, true)}%`}
                />
              )}

              {trueEmployerMatch && companyMatchDlrMax !== null && (
                <CardField
                  label='Max dollar match'
                  value={`$${numberToDollars(companyMatchDlrMax, true)}`}
                />
              )}
            </div>

            <Spacer space='4px' />
          </>
        )}

        {showProfitSharing && profitSharing !== null && (
          <CardField
            label='Fixed employer contribution or profit sharing?'
            value={profitSharing ? 'Yes' : 'No'}
          />
        )}

        {showProfitSharing && profitSharing && profitSharingRate !== null && (
          <CardField
            label='Expected percentage'
            // round off trailing decimal 0's like 4.00 and
            // round rate to two decimal places
            value={`${
              Number.isInteger(profitSharingRate)
                ? Math.round(profitSharingRate)
                : (Math.round(profitSharingRate * 100) / 100).toFixed(2)
            }%`}
          />
        )}

        {trueEmployerMatch === null && (
          <CardFieldError>
            GuidedChoice does not have data on record for this account
          </CardFieldError>
        )}

        <Drawer
          active={this.state.editActive}
          title='Employer contributions'
          subtitle='Edit account'
          width='50%'
          responsiveWidth
          onOverlayClick={this.handleCancel}
          onEscKeyDown={this.handleCancel}>
          <EditEmployerContributions handleCancel={this.handleCancel} />
        </Drawer>
      </RoundedCard>
    )
  }
}

export default inject('account', 'store')(observer(EditEmployerContributionsCard))
